import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_EXPENSE_SAP_MIGRATION,
  CLEAR_EXPENSE_SAP_MIGRATIONS,
  CLEAR_EXPENSE_SAP_MIGRATIONS_BY_EXPENSE,
  FLAG_EXPENSE_SAP_MIGRATION_ACTIVITY,
  FLAG_GETTING_EXPENSE_SAP_MIGRATIONS,
  GET_EXPENSE_SAP_MIGRATION,
  GET_EXPENSE_SAP_MIGRATIONS,
  GET_EXPENSE_SAP_MIGRATIONS_BY_EXPENSE,
} from '../../../actions/types/accounting/ExpenseSapMigration';

const EXPENSE_SAP_MIGRATION_INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),

  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  byExpense: Immutable.Map({
    content: Immutable.List(),
  }),
});

export default (
  state = EXPENSE_SAP_MIGRATION_INITIAL_STATE,
  { type, payload },
) => {
  switch (type) {
    case FLAG_GETTING_EXPENSE_SAP_MIGRATIONS:
      return state.setIn(['all', 'loading'], payload);

    case GET_EXPENSE_SAP_MIGRATIONS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));

    case CLEAR_EXPENSE_SAP_MIGRATIONS:
      return state.setIn(
        ['all', 'content'],
        EXPENSE_SAP_MIGRATION_INITIAL_STATE.getIn(['all', 'content']),
      );

    case FLAG_EXPENSE_SAP_MIGRATION_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );

    case GET_EXPENSE_SAP_MIGRATION:
      return state.setIn(['current', 'content'], Immutable.Map(payload));

    case CLEAR_EXPENSE_SAP_MIGRATION:
      return state.setIn(
        ['current'],
        EXPENSE_SAP_MIGRATION_INITIAL_STATE.getIn(['current']),
      );
    case GET_EXPENSE_SAP_MIGRATIONS_BY_EXPENSE:
      return state.setIn(['byExpense', 'content'], Immutable.List(payload));

    case CLEAR_EXPENSE_SAP_MIGRATIONS_BY_EXPENSE:
      return state.setIn(['byExpense', 'content'], Immutable.List());

    default:
      return state;
  }
};
